/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-c81d82ab.js';

const globalScripts = initialize;

export { globalScripts as g };
